import { render, staticRenderFns } from "./WalletOutlined.vue?vue&type=template&id=12166312"
import script from "./WalletOutlined.vue?vue&type=script&lang=js"
export * from "./WalletOutlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports